import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddressBook = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 9C9.60457 9 10.5 8.10457 10.5 7C10.5 5.89543 9.60457 5 8.5 5C7.39543 5 6.5 5.89543 6.5 7C6.5 8.10457 7.39543 9 8.5 9Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 6.75H3.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 4.25H3.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 9.25H3.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 11.75H3.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 10.5C5.8493 10.0343 6.30224 9.65625 6.82295 9.3959C7.34366 9.13554 7.91783 9 8.5 9C9.08217 9 9.65634 9.13554 10.1771 9.3959C10.6978 9.65625 11.1507 10.0343 11.5 10.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 13.5V2.5C13.5 2.22386 13.2761 2 13 2L4 2C3.72386 2 3.5 2.22386 3.5 2.5V13.5C3.5 13.7761 3.72386 14 4 14H13C13.2761 14 13.5 13.7761 13.5 13.5Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAddressBook;
